import React from "react";

const CatalogWidgetPage = () => {
  return (
    <div className="flex flex-col items-center w-full min-h-[60vh] pt-5 px-0">
      <div className="w-full flex flex-col items-center">
        <iframe
          id="acat-frame"
          src="https://parallel.acat.online"
          scrolling="auto"
          frameBorder="0"
          allow="clipboard-read; clipboard-write"
          style={{ borderRadius: 8, boxShadow: '0 2px 16px rgba(0,0,0,0.06)', minHeight: '600px', height: '75vh', width: '100%' }}
        ></iframe>
      </div>
      {/* Скрипт для автоувеличения высоты */}
      <script
        dangerouslySetInnerHTML={{
          __html: `window.addEventListener("message", function(e){try {var data = JSON.parse(e.data);if (data && data.acatFrameHeight) {document.getElementById("acat-frame").style.height = data.acatFrameHeight + "px";}} catch (e) {}}, false);`
        }}
      />
    </div>
  );
};

export default CatalogWidgetPage; 